import { FC, ReactNode, useState, useCallback } from 'react';
import AccordionContent from '../AccordionContent';
import AccordionTitle from '../AccordionTitle';
import { Root } from './styled';
import UpdateDesiredModal from 'components/connectivity/UpdateDesiredModal';
import { DesiredValue, DeviceShadowFeature } from 'models/connectivity';
import editIcon from 'assets/vectors/edit-icon.svg';
import desiredIcon from 'assets/vectors/desire.svg';
import { useIntl } from 'react-intl';

type Props = {
  children?: ReactNode;
  title: string;
  value?: string;
  modified?: number;
  writable?: boolean;
  desired?: DesiredValue;
  totalDesiredCount?: number;
  shadows?: DeviceShadowFeature[];
  selectedFeatureSpecification?: string;
};
const AccordionItem: FC<Props> = ({
  children,
  title,
  value,
  writable,
  modified,
  desired,
  totalDesiredCount,
  shadows,
  selectedFeatureSpecification,
}) => {
  const intl = useIntl();

  // State
  const [editActive, setActive] = useState<boolean>(false);
  // Open / close accordion
  const onClick = useCallback(
    (editActive: boolean) => {
      editActive = !editActive;
      setActive(!editActive);
    },
    [setActive]
  );

  const [openDesiredModal, setOpenDesiredModal] = useState(false);

  const handleEditDesiredValues = () => {
    setOpenDesiredModal(true);
  };

  const onClose = useCallback(() => {
    setOpenDesiredModal(false);
  }, [setOpenDesiredModal]);
  
  return (
    <Root $disableHover={openDesiredModal}>
      {children && (
        <div>
          <AccordionTitle
            title={title}
            active={editActive}
            setActive={onClick}
            modified={modified}
            isEditable={
              // Temporary filter on DataControl
              writable && title === 'DataControl'
            }
            editInfoMessage={intl.formatMessage({
              id: 'connectivity.edit_desired_btn',
            })}
            editIcon={editIcon}
            infoMessage={
              totalDesiredCount && totalDesiredCount > 0
                ? intl.formatMessage(
                    { id: 'connectivity.desired_info_message' },
                    { count: totalDesiredCount }
                  )
                : undefined
            }
            infoMessageIcon={desiredIcon}
            onEditClick={handleEditDesiredValues}
          />
          <AccordionContent active={editActive}>{children}</AccordionContent>
        </div>
      )}
      {value && (
        <div>
          <AccordionContent
            active={true}
            title={title}
            value={value}
            modified={modified}
            desired={desired}
          >
            {children}
          </AccordionContent>
        </div>
      )}
      {shadows?.find((ds) => ds.title === title) && (
        <UpdateDesiredModal
          selectedFamily={shadows.find((ds) => ds.title === title)!}
          open={openDesiredModal}
          onClose={onClose}
          specificationId={selectedFeatureSpecification || ''}
        />
      )}
    </Root>
  );
};

export default AccordionItem;
